export default "__VITE_ASSET__gmD8wZuN__"